// Desktop scrolls the feature; mobile scrolls the document under the sticky shell.
// Call only after a current report/catalog request has rendered its new content.
export function resetReportScroll(element) {
  if (element) element.scrollTop = 0;
  if (typeof window === 'undefined') return;
  const scrollingElement = document.scrollingElement || document.documentElement;
  if (scrollingElement) scrollingElement.scrollTop = 0;
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}
